var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRemoActions = function SvgRemoActions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.82 3.835a.5.5 0 0 1 .645.017l4.514 4.021a.5.5 0 1 0 .665-.746L10.13 3.105a1.5 1.5 0 0 0-1.935-.051l-5.59 4.472a.5.5 0 0 0 .624.781zm4.097-.585a.5.5 0 1 0 0 1h1.166v1.167a.5.5 0 0 0 1 0V3.75a.5.5 0 0 0-.5-.5zM5.083 9.167a.5.5 0 0 0-1 0v4.416a1.5 1.5 0 0 0 1.5 1.5h2.334a.5.5 0 1 0 0-1H5.583a.5.5 0 0 1-.5-.5zm7.39 1.336a.5.5 0 0 1 .87 0l3.038 5.342a.5.5 0 0 1-.435.747H9.87a.5.5 0 0 1-.435-.747zm1.74-.494a1.5 1.5 0 0 0-2.609 0L8.567 15.35a1.5 1.5 0 0 0 1.304 2.241h6.075a1.5 1.5 0 0 0 1.304-2.241zm-.737 2.564a.5.5 0 1 0-1 0v1.51a.5.5 0 0 0 1 0zm-.135 2.846a.426.426 0 0 1-.433.418.426.426 0 0 1-.432-.418c0-.231.194-.418.432-.418.24 0 .433.187.433.418",
    clipRule: "evenodd"
  })));
};
export default SvgRemoActions;